// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d8d2588e","145":"24c33649","180":"91422f19","269":"46c9af61","282":"ed3d40e6","309":"f7dfbad8","335":"c52c9b39","357":"c9988642","450":"e108b485","452":"d070067a","470":"edaa90c9","743":"68192cad","787":"561c407a","797":"ab7222c1"}[chunkId] + ".chunk.js";
};